/**
 * @flow
 * @relayHash 13556eba6ec8b0a95913353faf306d91
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SearchableStaffDropdownQueryVariables = {|
  staffName?: ?string,
  first?: ?number,
  orderBy?: ?string,
  includeInactive?: ?boolean,
|};
export type SearchableStaffDropdownQueryResponse = {|
  +staffByOrg: ?{|
    +edgeCount: ?number,
    +totalCount: ?number,
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +fullName: ?string,
      |}
    |}>,
  |}
|};
export type SearchableStaffDropdownQuery = {|
  variables: SearchableStaffDropdownQueryVariables,
  response: SearchableStaffDropdownQueryResponse,
|};
*/


/*
query SearchableStaffDropdownQuery(
  $staffName: String
  $first: Int
  $orderBy: String
  $includeInactive: Boolean
) {
  staffByOrg(staffName: $staffName, orderBy: $orderBy, first: $first, includeInactive: $includeInactive) {
    edgeCount
    totalCount
    edges {
      node {
        id
        fullName
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "staffName",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderBy",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "includeInactive",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "staffByOrg",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "includeInactive",
        "variableName": "includeInactive"
      },
      {
        "kind": "Variable",
        "name": "orderBy",
        "variableName": "orderBy"
      },
      {
        "kind": "Variable",
        "name": "staffName",
        "variableName": "staffName"
      }
    ],
    "concreteType": "StaffNodeConnection",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "edgeCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "totalCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "StaffNodeEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "StaffNode",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fullName",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SearchableStaffDropdownQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SearchableStaffDropdownQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "SearchableStaffDropdownQuery",
    "id": null,
    "text": "query SearchableStaffDropdownQuery(\n  $staffName: String\n  $first: Int\n  $orderBy: String\n  $includeInactive: Boolean\n) {\n  staffByOrg(staffName: $staffName, orderBy: $orderBy, first: $first, includeInactive: $includeInactive) {\n    edgeCount\n    totalCount\n    edges {\n      node {\n        id\n        fullName\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '017a308cc3241a718d154e3afce282bb';
module.exports = node;
